// extracted by mini-css-extract-plugin
module.exports = {"container":"FlagBrands-module--container--2gaY0","tabs":"FlagBrands-module--tabs--3hvQh","flags":"FlagBrands-module--flags--3TYyk","active":"FlagBrands-module--active--3Yev9"};